import { render, staticRenderFns } from "./SingleBtnDialog.vue?vue&type=template&id=73f35fc0"
import script from "./SingleBtnDialog.vue?vue&type=script&lang=js"
export * from "./SingleBtnDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports